/* global $ */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["wrapper", "input"];
  static values = { url: String, formId: String };

  connect() {
    this.initSearch();
  }

  disconnect() {
    $(this.wrapperTarget).search("destroy");
  }

  initSearch() {
    const formId = this.formIdValue;
    const input = this.inputTarget;

    $(this.wrapperTarget).search({
      type: "category",
      minCharacters: 2,
      apiSettings: {
        url: this.urlValue + "?q={query}",
        onResponse: (response) => response,
      },
      onSelect: (result) => {
        if (result.filter_type) {
          const url = new URL(window.location.href);
          // Clear text query when applying a filter
          url.searchParams.delete("query");
          if (result.filter_type === "tag") {
            url.searchParams.append("tag", result.title);
          } else if (result.filter_type === "topic") {
            url.searchParams.set("q[profile_topics_cont]", result.title);
          } else if (result.filter_type === "category") {
            url.searchParams.set("q[profile_category_eq]", result.title);
          }
          window.location.href = url.toString();
        } else {
          input.value = result.title;
          const form = document.getElementById(formId);
          if (form) form.submit();
        }
        return false;
      },
    });
  }
}
